var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoffee = function SvgCoffee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Coffee Mug Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.69 3.82a.51.51 0 0 1-.44-.5V3a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v14.5A4.51 4.51 0 0 0 4.5 22h8.25a4.5 4.5 0 0 0 4.36-3.42.49.49 0 0 1 .43-.38 7.24 7.24 0 0 0 .15-14.38M3.75 16a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 1.5 0Zm0-4a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 1.5 0Zm14.12 3.59a.5.5 0 0 1-.62-.48V6.89a.5.5 0 0 1 .62-.48 4.72 4.72 0 0 1 0 9.18"
  })));
};
export default SvgCoffee;